// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19wAE","comment":"styles_comment__1BzVs"};